import { UserAbility } from "modules/user/config/permissions/Can";

export const ability: Partial<UserAbility> = {
  todo_list: {
    read: ["all"],
    create: [
      "master",
      "executive",
      "administrator",
      "program_manager",
      "staff",
      "client"
    ],
    update: [
      "master",
      "executive",
      "administrator",
      "program_manager",
      "staff",
      "client"
    ],
    delete: [
      "master",
      "executive",
      "administrator",
      "program_manager",
      "staff",
      "client"
    ],
    config: ["master", "executive", "administrator", "program_manager"]
  },
  todo: {
    read: ["all"],
    create: [
      "master",
      "executive",
      "administrator",
      "program_manager",
      "staff",
      "client"
    ],
    update: [
      "master",
      "executive",
      "administrator",
      "program_manager",
      "staff",
      "client"
    ],
    delete: [
      "master",
      "executive",
      "administrator",
      "program_manager",
      "staff",
      "client"
    ],
    config: ["master", "executive", "administrator", "program_manager"]
  },
  crowdsource: {
    read: ["all"],
    create: ["all"],
    update: [
      "master",
      "executive",
      "program_manager",
      "administrator",
      "staff",
      "client"
    ],
    delete: [
      "master",
      "executive",
      "program_manager",
      "administrator",
      "staff",
      "client"
    ],
    config: ["master", "program_manager"]
  },
  brainstorming_idea: {
    read: ["all"],
    create: ["all"],
    update: ["master", "program_manager", "administrator", "staff", "client"],
    delete: ["master", "program_manager", "administrator", "staff", "client"],
    config: ["master", "program_manager", "administrator", "staff", "client"]
  }
};
